import { FactoryProvider } from '@angular/core';
import { InMemoryCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { createHttpLink } from '@apollo/client/link/http';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { appInjector } from 'app-injector';
import { environment } from 'environments';
import { AuthService } from './auth.service';
import possibleTypes from './codegen/possible-types.json';

function createApollo() {
  const cache = new InMemoryCache({
    dataIdFromObject: object => (object as any).id,
    possibleTypes,
  });

  const httpLink = createHttpLink({ uri: environment.THEWALL_URL });

  const authLink = setContext((_, { headers }) => {
    const authService = appInjector()?.get(AuthService);
    const roleToken = authService?.roleToken;
    return {
      headers: {
        ...headers,
        ...(roleToken ? { 'x-rt': roleToken } : {}),
      },
    };
  });

  return {
    link: authLink.concat(httpLink),
    cache,
  };
}

export const ApolloProvider: FactoryProvider = {
  provide: APOLLO_OPTIONS,
  useFactory: createApollo,
};

export { ApolloModule };
